// import
import Dashboard from "views/SchoolDashboard/Dashboard";

import {CreditIcon, HelpIcon, HomeIcon, RocketIcon,} from "components/Icons/Icons";
import Roster from "./views/SchoolDashboard/Roster";
import Setting from "./views/Dashboard/Setting/Setting";
import VirtualAnnouncement from "./views/SchoolDashboard/VirtualAnnouncement/VirtualAnnouncement";
import UserSetup from "./views/SchoolDashboard/UserSetup/UserSetup";
import Logout from "./views/Auth/Logout/Logout";
import SignUp from "./views/Auth/SignUp";
import BellDashboard from "./views/SchoolDashboard/BellDashboard/BellDashboard";
import MusicStudio from "./views/SchoolDashboard/MusicLibrary/MusicStudio";
import Help from "./views/SchoolDashboard/Help/Help";
import SettingsMenu from "./views/SchoolDashboard/Setting/SettingsMenu";
import SmartTimetable from "./views/SchoolDashboard/Timetable/SmartTimetable";
import DigitalPTPage from "./pages/DigitalPTPage";
import PhysicalTraining from "./views/Dashboard/PhysicalTraining/PhysicalTraining";
import {FiActivity} from "react-icons/fi";
import {MdAutoAwesome, MdCampaign, MdEventNote, MdFitnessCenter, MdNotificationsActive, MdSettings} from "react-icons/md";
import {MdChecklist, MdDashboardCustomize, MdDesignServices, MdHowToReg, MdPodcasts, MdTv} from "react-icons/md";
import {MdLibraryMusic} from "react-icons/md";
import {
    AttendanceDashboard,
    AttendanceRecords,
    DailyAttendance,
    LiveAttendance,
} from "./views/Dashboard/Attendance";
import {NoticeBoardDesigner, NoticeBoards} from "./views/Dashboard/NoticeBoard";
import {MdBadge, MdGroups, MdOutlinePrint, MdQrCode2, MdViewCarousel} from "react-icons/md";
import {IdCardDesigner, IdCardGenerate, IdCardTemplates} from "./views/Dashboard/IdCard";
import {HrisDashboard, Staff, StaffAttendanceQr} from "./views/Dashboard/HRIS";

var dashRoutes = [
    {
        path: "/dashboard",
        name: "Dashboard",
        nepaliName: "ड्यासबोर्ड",
        icon: <HomeIcon color="inherit"/>,
        component: Dashboard,
        layout: "/admin",
    },
    {
        path: "/bell-dashboard",
        name: "Bell Dashboard",
        nepaliName: "घण्टी ड्यासबोर्ड",
        icon: <MdNotificationsActive color="inherit"/>,
        component: BellDashboard,
        layout: "/admin",
    },
    {
        path: "/roster",
        name: "Roster",
        nepaliName: "अवधि सूची",
        rtlName: "لوحة القيادة",
        icon: <MdEventNote color="inherit"/>,
        component: Roster,
        layout: "/admin",
    },
    {
        path: "/virtual-announcement",
        name: "Virtual Announcement",
        nepaliName: "भर्चुअल घोषणा",
        rtlName: "لوحة القيادة",
        icon: <MdCampaign color="inherit"/>,
        component: VirtualAnnouncement,
        layout: "/admin",
    },
    {
        path: "/music-library",
        name: "Music Library",
        nepaliName: "संगीत पुस्तकालय",
        rtlName: "لوحة القيادة",
        icon: <MdLibraryMusic color="inherit"/>,
        component: MusicStudio,
        layout: "/admin",
    },
    {
        path: "/physical-training",
        name: "Physical Training",
        nepaliName: "शारीरिक प्रशिक्षण",
        icon: <MdFitnessCenter color="inherit"/>,
        component: PhysicalTraining,
        layout: "/admin",
    },
    {
        path: "/smart-timetable",
        name: "Smart Timetable",
        nepaliName: "स्मार्ट समय तालिका",
        rtlName: "لوحة القيادة",
        icon: <MdAutoAwesome color="inherit"/>,
        component: SmartTimetable,
        layout: "/admin",
    },
    // {
    //     path: "/digital-pt",
    //     name: "Digital PT",
    //     nepaliName: "डिजिटल पीटी",
    //     icon: <FiActivity color="inherit"/>,
    //     component: DigitalPTPage,
    //     layout: "/admin",
    // },
    {
        path: "/help",
        name: "Help",
        nepaliName: "सहायता",
        rtlName: "لوحة القيادة",
        icon: <HelpIcon color="inherit"/>,
        component: Help,
        layout: "/admin",
    },
    {
        path: "/settings",
        name: "Settings",
        nepaliName: "सेटिङ",
        rtlName: "لوحة القيادة",
        icon: <MdSettings color="inherit"/>,
        component: SettingsMenu,
        layout: "/admin",
    },
    {
        name: "DIGITAL NOTICE BOARD",
        nepaliName: "डिजिटल सूचना पाटी",
        category: "noticeBoard",
        state: "noticeBoardCollapse",
        views: [
            {
                path: "/notice-board/boards",
                name: "Notice Boards",
                nepaliName: "सूचना पाटीहरू",
                icon: <MdTv color="inherit"/>,
                component: NoticeBoards,
                layout: "/admin",
            },
            {
                path: "/notice-board/designer",
                name: "Board Designer",
                nepaliName: "पाटी डिजाइनर",
                icon: <MdDesignServices color="inherit"/>,
                component: NoticeBoardDesigner,
                layout: "/admin",
            },
        ],
    },
    // {
    //     name: "ID CARD STUDIO",
    //     nepaliName: "परिचयपत्र स्टुडियो",
    //     category: "idCard",
    //     state: "idCardCollapse",
    //     views: [
    //         {
    //             path: "/id-card/templates",
    //             name: "Card Templates",
    //             nepaliName: "कार्ड टेम्प्लेटहरू",
    //             icon: <MdViewCarousel color="inherit"/>,
    //             component: IdCardTemplates,
    //             layout: "/admin",
    //         },
    //         {
    //             path: "/id-card/designer",
    //             name: "Card Designer",
    //             nepaliName: "कार्ड डिजाइनर",
    //             icon: <MdBadge color="inherit"/>,
    //             component: IdCardDesigner,
    //             layout: "/admin",
    //         },
    //         {
    //             path: "/id-card/generate",
    //             name: "Generate & Print",
    //             nepaliName: "उत्पादन र प्रिन्ट",
    //             icon: <MdOutlinePrint color="inherit"/>,
    //             component: IdCardGenerate,
    //             layout: "/admin",
    //         },
    //     ],
    // },
    // {
    //     name: "HRIS",
    //     nepaliName: "कर्मचारी व्यवस्थापन",
    //     category: "hris",
    //     state: "hrisCollapse",
    //     views: [
    //         {
    //             path: "/hris/dashboard",
    //             name: "Dashboard",
    //             nepaliName: "ड्यासबोर्ड",
    //             icon: <MdDashboardCustomize color="inherit"/>,
    //             component: HrisDashboard,
    //             layout: "/admin",
    //         },
    //         {
    //             path: "/hris/staff",
    //             name: "Staff",
    //             nepaliName: "कर्मचारी",
    //             icon: <MdGroups color="inherit"/>,
    //             component: Staff,
    //             layout: "/admin",
    //         },
    //         {
    //             path: "/hris/attendance",
    //             name: "Attendance",
    //             nepaliName: "हाजिरी",
    //             icon: <MdQrCode2 color="inherit"/>,
    //             component: StaffAttendanceQr,
    //             layout: "/admin",
    //         },
    //     ],
    // },
    // {
    //     name: "ATTENDANCE",
    //     nepaliName: "हाजिरी",
    //     category: "attendance",
    //     state: "attendanceCollapse",
    //     views: [
    //         {
    //             path: "/attendance/dashboard",
    //             name: "Attendance Home",
    //             nepaliName: "हाजिरी गृह",
    //             icon: <MdDashboardCustomize color="inherit"/>,
    //             component: AttendanceDashboard,
    //             layout: "/admin",
    //         },
    //         {
    //             path: "/attendance/daily",
    //             name: "Daily Attendance",
    //             nepaliName: "दैनिक हाजिरी",
    //             icon: <MdHowToReg color="inherit"/>,
    //             component: DailyAttendance,
    //             layout: "/admin",
    //         },
    //         {
    //             path: "/attendance/records",
    //             name: "Attendance Records",
    //             nepaliName: "हाजिरी अभिलेख",
    //             icon: <MdChecklist color="inherit"/>,
    //             component: AttendanceRecords,
    //             layout: "/admin",
    //         },
    //         {
    //             path: "/attendance/live",
    //             name: "Live Monitor",
    //             nepaliName: "प्रत्यक्ष अनुगमन",
    //             icon: <MdPodcasts color="inherit"/>,
    //             component: LiveAttendance,
    //             layout: "/admin",
    //         },
    //     ],
    // },
    {
        name: "ACCOUNT",
        nepaliName: "खाता",
        category: "account",
        rtlName: "صفحات",
        state: "pageCollapse",
        views: [
            // {
            //     path: "/user-setup",
            //     name: "User Setup",
            //     nepaliName: "प्रयोगकर्ता सेटअप",
            //     icon: <RocketIcon color="inherit"/>,
            //     component: UserSetup,
            //     layout: "/admin",
            // },
            {
                path: "/logout",
                name: "Sign Out",
                nepaliName: "साइन आउट",
                icon: <RocketIcon color="inherit"/>,
                component: Logout,
                layout: "/auth",
            },
            // {
            //     path: "/signup",
            //     name: "Sign Up",
            //     nepaliName: "साइन अप",
            //     rtlName: "لوحة القيادة",
            //     icon: <RocketIcon color="inherit"/>,
            //     secondaryNavbar: true,
            //     component: SignUp,
            //     layout: "/auth",
            // },
        ],
    },
];
export default dashRoutes;
